<template>
  <div class="content">
    <el-dialog v-bind="$attrs" v-on="$listeners" @open="onOpen" title="角色分配">
      <el-form
        ref="addRef"
        :model="userInfo"
        :rules="rules"
        size="medium"
        label-width="100px"
        label-position="top"
      >
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="用户名称" prop="name">
              <el-input
                v-model="userInfo.name"
                clearable
                disabled
                :style="{ width: '100%' }"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工号" prop="workNumber">
              <el-input
                disabled
                v-model="userInfo.workNumber"
                clearable
                :style="{ width: '100%' }"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="公司名称" prop="companyName">
              <el-input
                disabled
                v-model="userInfo.companyName"
                clearable
                :style="{ width: '100%' }"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="部门名称" prop="departmentName">
              <el-input
                disabled
                v-model="userInfo.departmentName"
                clearable
                :style="{ width: '100%' }"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <div style="text-align: center">
            <el-transfer
              style="text-align: left; display: inline-block"
              v-model="form.roleIds"
              filterable
              :titles="['全部权限', '已选权限']"
              :button-texts="['到左边', '到右边']"
               @change="handleChange"
              :data="allRoles"
              :props="{
                key: 'id',
                label: 'authName',
              }"
            >
              <span slot-scope="{ option }">{{ option.name }}</span>
              <!-- <span slot-scope="{ option }">{{ option.id }} - {{ option.authName }}</span> -->
            </el-transfer>
          </div>
        </el-row>
      </el-form>
      <div slot="footer" v-if="true">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handelConfirm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {getAllRoles,getUserInfoForRoles,assignRoles}  from '@/api/systemData'

const cityOptions = ["上海", "北京", "广州", "深圳"];
export default {
  inheritAttrs: false,
  props: ["data"],
  data() {
    return {
      allRoles: [],
      form: {
        id: 0,
        roleIds: [],
      },
      userInfo: {
        name: "",
        workNumber:"",
        companyName: "",
        departmentName:"",
      },
      rules: {
        name: [
          {
            required: true,
            message: "名称不能为空",
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: "编码不能为空",
            trigger: "blur",
          },
        ],
        description: [
          {
            required: true,
            message: "描述不能为空",
            trigger: "blur",
          },
        ],
        companyId: [
          {
            required: true,
            message: "企业不能为空",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {},
  watch: {
    data: {
      deep: true,
      handler(newData) {
        let newValue = {
          ...newData,
        };
        this.userInfo = newValue;
        this.getDataInfo(this.userInfo.id);
      },
    },
  },
  created() {},
  mounted() {},
  methods: {
    handleChange(value, direction, movedKeys) {
      console.log(value, direction, movedKeys);
    },
    getAllRoles() {
      getAllRoles().then((res) => {
        if (res.code == 10000) {
          this.allRoles = res.data;
          console.log("allRoles",this.allRoles);
        }
      });
    },
    async getDataInfo(id) {
      let res = await getUserInfoForRoles(id);
      console.log("roles-res",res);
      if (res.code == 10000) {
        this.form.id = id;
        this.form.roleIds = res.data;
      }
    },
    onOpen() {},
    onClose() {
      this.$refs["addRef"].resetFields();
    },
    close() {
      this.$emit("update:visible", false);
    },
    handelConfirm() {
      console.log("this.form",this.form);
      assignRoles(this.form).then((res)=>{
        if(res.code == 10000){
          this.form.id = 0;
          this.form.roleIds = [];
          this.$emit("add-success");
          this.close();
          this.$message.success("添加角色成功");
        }
      })
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  background-color: #fff;
  padding: 10px;
}
::v-deep .el-dialog__body {
  padding: 30px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
  height: 600px;
  overflow: auto;
}
</style>
